import { useQuery } from '@tanstack/react-query';
import { ISystemMail } from '../../Interfaces/ISystemMail';
import { customFetcher } from '../useFetch';
import { ISystemMailCategory } from '../../Interfaces/ISystemMailCategory';
import { ISystemMail_has_Dictionary } from '../../Interfaces/ISystemMail_has_Dictionary';

export const useGetSystemMails = () => {
  const { data: systemMails, isLoading: isLoadingSystemMails } = useQuery<
    ISystemMail[]
  >({
    queryKey: ['systemmail'],
    queryFn: () => customFetcher({ endpoint: '/systemmail' }),
  });

  return { systemMails, isLoadingSystemMails };
};

export const useGetSystemMail = (systemMailId: number) => {
  const { data: systemMail, isLoading: isLoadingSystemMail } =
    useQuery<ISystemMail>({
      refetchOnWindowFocus: false,
      queryKey: ['systemmail', systemMailId],
      queryFn: () => customFetcher({ endpoint: `/systemmail/${systemMailId}` }),
    });

  return { systemMail, isLoadingSystemMail };
};

export const useGetSystemMailCategories = () => {
  const {
    data: systemMailCategories,
    isLoading: isLoadingSystemMailCategories,
  } = useQuery<ISystemMailCategory[]>({
    queryKey: ['systemmailcategory'],
    queryFn: () => customFetcher({ endpoint: '/systemmailcategory' }),
  });

  return { systemMailCategories, isLoadingSystemMailCategories };
};

export const useGetSystemMailHasDictionary = () => {
  const {
    data: systemMailHasDictionary,
    isLoading: isLoadingSystemMailHasDictionary,
  } = useQuery<ISystemMail_has_Dictionary[]>({
    queryKey: ['systemmail_has_dictionary'],
    queryFn: () => customFetcher({ endpoint: '/systemmail_has_dictionary' }),
  });

  return { systemMailHasDictionary, isLoadingSystemMailHasDictionary };
};
